import { render } from "./D_createChannel.vue?vue&type=template&id=21dfb99f&scoped=true"
import script from "./D_createChannel.vue?vue&type=script&lang=js"
export * from "./D_createChannel.vue?vue&type=script&lang=js"

import "./D_createChannel.vue?vue&type=style&index=0&id=21dfb99f&scoped=true&lang=css"
/* custom blocks */
import block0 from "./D_createChannel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21dfb99f"]])

export default __exports__